module.exports = __webpack_public_path__ + "img/multiplier_64_win.f7890dbc.png";